import { adjust } from '../adapters/adjustAdapter'

export default () => {
  adjust.clearUser()
}
